export const HEADER_ACTION_ID = "x-rsc-action";
export const RSC_MEDIA_TYPE = "text/x-component";
